import {useEffect, useRef} from "react";

import {OfferViewSectionName, trackAmplitudeOfferViewSection} from "../../tracking/amplitude/track_amplitude_offer_view_section";

interface IOfferViewSectionTrackerProps {
    itemId: number;
    sectionName: OfferViewSectionName;
}

interface IOfferViewTrackingState {
    itemId: number;
    trackedSections: Set<OfferViewSectionName>;
}

const trackedSectionsByPage = new WeakMap<Element, IOfferViewTrackingState>();
const sectionHeadingSelector = "h1, h2, h3, h4, h5, h6";

const getSectionElement = (sentinel: HTMLSpanElement | null): Element | null => {
    let nextElement = sentinel?.nextElementSibling ?? null;

    while (nextElement?.hasAttribute("hidden")) {
        nextElement = nextElement.nextElementSibling;
    }

    const sectionElement = nextElement ?? sentinel?.parentElement ?? null;

    if (sectionElement === null) {
        return null;
    }

    return sectionElement.matches(sectionHeadingSelector) ? sectionElement : (sectionElement.querySelector(sectionHeadingSelector) ?? sectionElement);
};

export const OfferViewSectionTracker = ({itemId, sectionName}: IOfferViewSectionTrackerProps) => {
    const sentinelRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        const pageElement = sentinel?.closest("article") ?? null;
        const sectionElement = getSectionElement(sentinel);

        if (pageElement === null || sectionElement === null || typeof window === "undefined" || !("IntersectionObserver" in window)) {
            return;
        }

        let isActive = true;
        const observer = new window.IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (isActive && entry.target === sectionElement && entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        const currentState = trackedSectionsByPage.get(pageElement);
                        const trackingState =
                            currentState?.itemId === itemId
                                ? currentState
                                : {
                                      itemId,
                                      trackedSections: new Set<OfferViewSectionName>()
                                  };

                        if (trackingState.trackedSections.has(sectionName)) {
                            return;
                        }

                        trackedSectionsByPage.set(pageElement, trackingState);
                        trackingState.trackedSections.add(sectionName);
                        trackAmplitudeOfferViewSection({sectionName, itemId});
                    }
                });
            },
            {threshold: [0.5]}
        );

        observer.observe(sectionElement);

        return () => {
            isActive = false;
            observer.unobserve(sectionElement);
            observer.disconnect();
        };
    }, [itemId, sectionName]);

    return <span ref={sentinelRef} hidden aria-hidden="true" />;
};
import {useEffect, useRef} from "react";

import {OfferViewSectionName, trackAmplitudeOfferViewSection} from "../../tracking/amplitude/track_amplitude_offer_view_section";

interface IOfferViewSectionTrackerProps {
    itemId: number;
    sectionName: OfferViewSectionName;
}

interface IOfferViewTrackingState {
    itemId: number;
    trackedSections: Set<OfferViewSectionName>;
}

const trackedSectionsByPage = new WeakMap<Element, IOfferViewTrackingState>();
const sectionHeadingSelector = "h1, h2, h3, h4, h5, h6";

const getSectionElement = (sentinel: HTMLSpanElement | null): Element | null => {
    let nextElement = sentinel?.nextElementSibling ?? null;

    while (nextElement?.hasAttribute("hidden")) {
        nextElement = nextElement.nextElementSibling;
    }

    const sectionElement = nextElement ?? sentinel?.parentElement ?? null;

    if (sectionElement === null) {
        return null;
    }

    return sectionElement.matches(sectionHeadingSelector) ? sectionElement : (sectionElement.querySelector(sectionHeadingSelector) ?? sectionElement);
};

export const OfferViewSectionTracker = ({itemId, sectionName}: IOfferViewSectionTrackerProps) => {
    const sentinelRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        const pageElement = sentinel?.closest("article") ?? null;
        const sectionElement = getSectionElement(sentinel);

        if (pageElement === null || sectionElement === null || typeof window === "undefined" || !("IntersectionObserver" in window)) {
            return;
        }

        let isActive = true;
        const observer = new window.IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (isActive && entry.target === sectionElement && entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        const currentState = trackedSectionsByPage.get(pageElement);
                        const trackingState =
                            currentState?.itemId === itemId
                                ? currentState
                                : {
                                      itemId,
                                      trackedSections: new Set<OfferViewSectionName>()
                                  };

                        if (trackingState.trackedSections.has(sectionName)) {
                            return;
                        }

                        trackedSectionsByPage.set(pageElement, trackingState);
                        trackingState.trackedSections.add(sectionName);
                        trackAmplitudeOfferViewSection({sectionName, itemId});
                    }
                });
            },
            {threshold: [0.5]}
        );

        observer.observe(sectionElement);

        return () => {
            isActive = false;
            observer.unobserve(sectionElement);
            observer.disconnect();
        };
    }, [itemId, sectionName]);

    return <span ref={sentinelRef} hidden aria-hidden="true" />;
};
